import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Chip, Box } from '@mui/material';
import { useProject } from '../../hooks/ProjectContext';

function fmtDate(iso) {
  if (!iso) return '';
  return new Date(iso).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export default function ChangeLogPage() {
  const { selectedProject } = useProject();
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    if (!selectedProject?.id) return;
    fetch(`/v1/change-log?projectId=${selectedProject.id}&limit=200`)
      .then(r => r.ok ? r.json() : []).then(setLogs).catch(() => setLogs([]));
  }, [selectedProject?.id]);

  return (
    <>
      <Helmet><title>Change Log | TERRRA</title></Helmet>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Typography variant="h5" gutterBottom>Change Log</Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          All changes to project data are recorded with timestamp and user.
        </Typography>
        <TableContainer sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>Date</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>User</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>Action</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>Entity</TableCell>
                <TableCell sx={{ fontWeight: 700, fontSize: 12 }}>Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {logs.map(log => (
                <TableRow key={log.id} hover>
                  <TableCell sx={{ fontSize: 11, whiteSpace: 'nowrap' }}>{fmtDate(log.created_at)}</TableCell>
                  <TableCell sx={{ fontSize: 11 }}>{log.user_email || '—'}</TableCell>
                  <TableCell><Chip label={log.action} size="small" sx={{ fontSize: 10, height: 18 }} /></TableCell>
                  <TableCell sx={{ fontSize: 11 }}>{log.entity}{log.entity_id ? ` #${log.entity_id}` : ''}</TableCell>
                  <TableCell sx={{ fontSize: 11 }}>{log.details || ''}</TableCell>
                </TableRow>
              ))}
              {logs.length === 0 && (
                <TableRow><TableCell colSpan={5}>
                  <Typography variant="caption" color="text.secondary">No changes recorded yet.</Typography>
                </TableCell></TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
}
